export default "__VITE_ASSET__DNdiwcam__"